"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Images_1 = require("../../../utils/Images");
var FETCH_ALL_APPS_QUERY = "query MyBoxApps {\n  myBoxApps {\n    id\n    mandatory\n    favourite\n    lastOpened\n    canUnfavourite\n    suggestedTileImage(aspectRatio: " + Images_1.IMAGE_RATIOS.HORIZONTAL + ") {\n      uri\n    }\n  }\n}";
exports.default = FETCH_ALL_APPS_QUERY;
//# sourceMappingURL=fetchAllApps.js.map